<template>
    <div class="entryDetails" id="entryDetails" ref="entryDetails">
        <transition v-if="editorView" name="fadeIn" appear>
            <EditorView
                ref="editorView"
                :currentArtwork="currentArtwork"
                :currentEntryId="currentEntryId"
                @finishEditing="setEditorView(false)"
                @setEditorViewHeight="setEditorViewHeight"/>
        </transition>

        <transition v-else name="fadeIn" appear>
            <VisitorView
                ref="visitorView"
                :currentArtwork="currentArtwork"
                :currentEntryId="currentEntryId"
                @setEditorView="setEditorView"
                @setVisitorViewHeight="setVisitorViewHeight"/>
        </transition>
    </div>
</template>

<script>
    import VisitorView from '@/components/entry/VisitorView'
    import EditorView  from '@/components/entry/EditorView'

    export default {
        name: 'EntryDetails',
        components: {
            VisitorView,
            EditorView
        },
        props: {
            currentArtwork: Object,
            currentEntryId: String,
            editorView: Boolean
        },
        methods: {
            setVisitorViewHeight(height) {
                this.$refs.entryDetails.setAttribute("style",`height:${height}px`)
            },
            setEditorViewHeight(height) {
                this.$refs.entryDetails.setAttribute("style",`height:${height}px`)
            },
            setEditorView(state) {
                this.$emit('setEditorView', state)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .entryDetails {
        position: relative;
        max-width: 80rem;
        width: 100%;
        transition: $transition-eio-60;
    }

    .fadeIn-enter-active, .fadeIn-leave-active {
        transition: $transition-eio-60;
    }

    .fadeIn-enter, .fadeIn-leave {
        opacity: 0;
        transform: translateY(5rem);
    }

    .fadeIn-enter-to {
        opacity: 1;
        transform: translateY(0);
    }

    .fadeIn-leave-to {
        opacity: 0;
        transform: translateY(-5rem);
    }

    @media all and (max-width: 1440px) {
        .entryDetails {
            max-width: 72rem;
        }
    }
</style>